import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getPublicSiteUrl, shouldNoindexPath } from '@/lib/seo';
import { buildHreflangAlternateLinks } from '@/lib/intl-seo';

/**
 * Tüm genel sayfalarda alternatif dil URL’leri (hreflang + x-default).
 */
export function HreflangLinks() {
  const location = useLocation();
  const site = getPublicSiteUrl();
  if (shouldNoindexPath(location.pathname)) return null;
  if (location.search && location.search.length > 1) return null;
  const links = buildHreflangAlternateLinks(site, location.pathname, '');

  if (!links.length) return null;

  return (
    <Helmet>
      {links.map((l) => (
        <link key={`${l.hreflang}-${l.href}`} rel="alternate" hrefLang={l.hreflang} href={l.href} />
      ))}
    </Helmet>
  );
}
